import { render, staticRenderFns } from "./WidgetsAdmin.vue?vue&type=template&id=03f5e812&scoped=true"
import script from "./WidgetsAdmin.vue?vue&type=script&lang=js"
export * from "./WidgetsAdmin.vue?vue&type=script&lang=js"
import style0 from "./WidgetsAdmin.vue?vue&type=style&index=0&id=03f5e812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f5e812",
  null
  
)

export default component.exports